import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IMedicalOffice } from '@app/01.global/interfaces/iMedicalOffice';
import { DatatableFilters } from '@app/01.global/models/DatatableFilters';
import { IApiResponse } from '../interfaces/helpers/iResponseWrapper';
import { environment } from '@environments/environment';
import '@app/01.global/helpers/observable-extensions';
import { Observable } from 'rxjs';
import { ITableListService } from '../../table-list/services/iservice';
import { BaseService } from './base.service';

@Injectable({
	providedIn: 'root',
})
export class MedicalOfficesService
	extends BaseService
	implements ITableListService
{
	ApiBaseURL = environment.ApiBaseURL;

	constructor(private http: HttpClient) {
		super();
	}

	create(model: IMedicalOffice): Observable<IMedicalOffice> {
		return this.http
			.post<IApiResponse>(`${this.ApiBaseURL}/MedicalOffices/`, model)
			.ToApiResult() as Observable<IMedicalOffice>;
	}

	update(id: number, model: IMedicalOffice): Observable<IMedicalOffice> {
		return this.http
			.put<IApiResponse>(`${this.ApiBaseURL}/MedicalOffices/${id}`, model)
			.ToApiResult() as Observable<IMedicalOffice>;
	}

	delete(id: number) {
		return this.http
			.delete<IApiResponse>(`${this.ApiBaseURL}/MedicalOffices/${id}`)
			.ToApiResult();
	}

	readCount(page: DatatableFilters): Observable<number> {
		let params = this.paginationToHttpParams(page);
		return this.http
			.get<IApiResponse>(`${this.ApiBaseURL}/MedicalOffices/count`, {
				params,
			})
			.ToApiResult();
	}

	readAll(page: DatatableFilters): Observable<IMedicalOffice[]> {
		let params = this.paginationToHttpParams(page);

		return this.http
			.get<IApiResponse>(`${this.ApiBaseURL}/MedicalOffices`, {
				params,
			})
			.ToApiResult();
	}

	read(id: number): Observable<IMedicalOffice> {
		return this.http
			.get<IApiResponse>(`${this.ApiBaseURL}/MedicalOffices/${id}`)
			.ToApiResult();
	}
}
